<template>
  <div class="wl-results" v-if="doc">
    <results-bar
      :doc="doc"
      @loadSummary="loadSummary"
      @loadUser="loadUser"
      :tiles="tiles"
    ></results-bar>
    <results-summary
      v-if="mode === 'summary'"
      :id="doc.id"
      :summaryMode="summaryMode"
      :model="model"
      :tiles="tiles"
      :localTiles="tiles"
      :key="model"
    ></results-summary>
    <results-user
      v-if="mode === 'user'"
      :uid="currentUser"
      :model="model"
      :localTitles="tiles"
    ></results-user>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  ResultsSummary,
  ResultsUser,
  ResultsBar,
} from "@/components/results/tiles";
const fb = require("@/firebaseConfig.js");

export default {
  name: "ResultTiles",
  props: {
    doc: {
      type: Object,
      default: null,
    },
    model: String,
  },
  data() {
    return {
      summary: true,
      summaryMode: "collated",
      currentUser: null,
      userList: null,
      tiles: [],
      mode: "summary",
    };
  },
  computed: {
    ...mapState(["exTiles"]),
  },
  components: {
    ResultsSummary,
    ResultsUser,
    ResultsBar,
  },
  mounted() {
    this.getExercise();
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.mode = "summary";
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.mode = "user";
    },
    getExercise() {
      let ref = fb[this.model].where("pid", "==", this.doc.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          let users = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            users.push(post.uid);
            post.selectedTiles.forEach((img) => {
              items.push(img);
            });
          });
          if (items) {
            this.tiles = items;
          }
          if (users) {
            this.userList = users;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
